module.exports = __webpack_public_path__ + "img/pic-3.644c16ab.png";